<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />
<div class="sidebar" [ngClass]="{
  'expanded': isExpanded,
  'is_project-nav-collapsed': !isExpanded}">
  <div class="header" (click)="handleSidebarToggle($event)">
    <span class="trigger-icon">
      <span class="trigger-icon__inner">
        <span class="trigger-icon__line"></span>
      </span>
    </span>
  </div>
  <div class="content">
      <div  class="sidebar-group-bd-top">
        <ng-container *ngFor="let menu of data">
          <ng-container *ngIf="canAccess(menu)">
            <div class="link" [ngClass]="{'with-children': hasChild(menu)}">
              <button type="button" class="content content-toggle"
                  *ngIf="hasChild(menu); else leafMenu"
                  [class.active]="isMenuActive(menu)"
                  (click)="expandCollapseChild($event, menu)">
                <div class="icon">
                  <ng-container *ngIf="menu.icon?.endsWith('.svg'); else fontIcon">
                    <svg-icon class="sidebar-svg" [src]="menu.icon"></svg-icon>
                  </ng-container>
                  <ng-template #fontIcon>
                    <i [ngClass]="menu.icon" style="font-size: 24px;"></i>
                  </ng-template>
                </div>
                <div class="sidebar-title" tooltip="Text" careposiTranslate>
                  <span class="menu-label">{{menu.title}}<span *ngIf="showPendingTagMarker(menu)"
                    class="pending-tag-marker" role="img" [attr.aria-label]="TEXT_COMMON.TAG_NOT_APPLIED"></span></span>
                </div>
                <span *ngIf="!isExpanded && showPendingTagMarker(menu)" class="pending-tag-marker pending-tag-marker-collapsed"
                  role="img" [attr.aria-label]="TEXT_COMMON.TAG_NOT_APPLIED"></span>
                <!-- up down icon for parent has child-->
                <div class="expand-collapse">
                  <span class="chevron-icon" [class.is-open]="menu.title && openedMenuTitles.includes(menu.title)"></span>
                  <!-- <i class="pi pi-chevron-down" *ngIf="openedMenuTitle !== menu.title"></i>
                  <i class="pi pi-chevron-up" *ngIf="openedMenuTitle === menu.title"></i> -->
                </div>
              </button>
              <ng-template #leafMenu>
                <a class="content"
                    [class.active]="isMenuActive(menu)"
                    [routerLink]="menu.path ? [menu.path] : null"
                    [routerLinkActive]="'active'"
                    [routerLinkActiveOptions]="{ exact: false }">
                  <div class="icon">
                    <ng-container *ngIf="menu.icon?.endsWith('.svg'); else fontIcon">
                      <svg-icon class="sidebar-svg" [src]="menu.icon"></svg-icon>
                    </ng-container>
                    <ng-template #fontIcon>
                      <i [ngClass]="menu.icon" style="font-size: 24px;"></i>
                    </ng-template>
                  </div>
                  <div class="sidebar-title" tooltip="Text" careposiTranslate>{{menu.title}}</div>
                </a>
              </ng-template>

              <!-- child menu -->
              <div class="children" *ngIf="hasChild(menu) && menu.title" [class.is-open]="openedMenuTitles.includes(menu.title)">
                <ng-container *ngFor="let childMenu of menu.children">
                  <div class="link" [ngClass]="{'with-children': hasChild(childMenu)}">

                    <!-- level 2: If has children → toggle button (sub-group) -->
                    <button type="button" class="content content-toggle"
                        *ngIf="hasChild(childMenu); else childLeafMenu"
                        [class.active]="isMenuActive(childMenu)"
                        (click)="handleChildToggle($event, menu, childMenu)">
                      <div class="sidebar-title" careposiTranslate>{{childMenu.title}}</div>
                      <div class="expand-collapse" (click)="expandCollapseChild($event, childMenu)">
                        <span class="chevron-icon" [class.is-open]="childMenu.title && openedMenuTitles.includes(childMenu.title)"></span>
                      </div>
                    </button>

                    <!-- level 2: If has no children → leaf link -->
                    <ng-template #childLeafMenu>
                      <a class="content" [routerLink]="[childMenu.path]" [routerLinkActive]="'active'"
                      (click)="onChildClick(menu, childMenu)">
                        <div class="sidebar-title" careposiTranslate>
                          <span class="menu-label">{{childMenu.title}}<span *ngIf="showPendingTagMarker(childMenu)"
                            class="pending-tag-marker" role="img" [attr.aria-label]="TEXT_COMMON.TAG_NOT_APPLIED"></span></span>
                        </div>
                      </a>
                    </ng-template>

                    <!-- level 3 -->
                    <div class="children children--level-3"
                         *ngIf="hasChild(childMenu) && childMenu.title"
                         [class.is-open]="openedMenuTitles.includes(childMenu.title)">
                      <ng-container *ngFor="let grandChild of childMenu.children">
                        <div class="link">
                          <a class="content" [routerLink]="[grandChild.path]"
                             [routerLinkActive]="'active'"
                             (click)="onGrandChildClick(menu, childMenu, grandChild)">
                            <div class="sidebar-title" careposiTranslate>{{grandChild.title}}</div>
                          </a>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

  </div>
  <div class="footer"></div>
</div>
